'use strict';

var React = require('react');
var Typography = require('../../DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AlertCaptionMessage = function AlertCaptionMessage(_ref) {
  var captionMessage = _ref.captionMessage;
  return React__default["default"].createElement(Typography, null, captionMessage);
};

module.exports = AlertCaptionMessage;
